// src/data/medicationsList.js

export const medicationsList = [
  { id: 1, name: 'Paracetamol 500mg' },
  { id: 2, name: 'Ibuprofen 200mg' },
  { id: 3, name: 'Amoxicillin 500mg' },
  // Add more medications as needed
];
